import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {mediaQueries} from "@khan/shared-styles";

import Illustration from "./illustration.tsx";
import InfoBlock from "./info-block.tsx";
import {SerifHeadingDistrictsTitle} from "./typography/typography.ts";

type Props = {
    kind: "InfoBlockGroup";
    headline: string;
    backgroundIllustration?: string;
    blocks: ReadonlyArray<
        JSX.LibraryManagedAttributes<
            typeof InfoBlock,
            React.ComponentProps<typeof InfoBlock>
        >
    >;
    startingAlignment: "left" | "right";
};

export default class InfoBlockGroup extends React.Component<Props> {
    render(): React.ReactNode {
        const {headline, backgroundIllustration, blocks, startingAlignment} =
            this.props;

        const alignmentChooser = [
            startingAlignment,
            startingAlignment === "left" ? "right" : "left",
        ];

        return (
            <View
                style={[
                    styles.container,
                    backgroundIllustration === "BackgroundBlob" &&
                        styles.paddedContainer,
                ]}
            >
                {backgroundIllustration && (
                    <Illustration name={backgroundIllustration} />
                )}

                <header className={css(styles.header)}>
                    <SerifHeadingDistrictsTitle tag="h2">
                        {headline}
                    </SerifHeadingDistrictsTitle>
                </header>

                {blocks.map((block, i) => (
                    <View
                        style={
                            backgroundIllustration !== "BackgroundBlob" &&
                            styles.paddedBlockContainer
                        }
                        key={i}
                    >
                        {/* @ts-expect-error - TS2322 - Type 'string' is not assignable to type '"left" | "right" | undefined'. */}
                        <InfoBlock {...block} align={alignmentChooser[i % 2]} />
                    </View>
                ))}
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        margin: "80px 0 0 0",

        [mediaQueries.mdOrLarger]: {
            marginBottom: 32,
        },
        [mediaQueries.lgOrLarger]: {
            marginBottom: 96,
        },
    },
    header: {
        paddingTop: 40,
        paddingBottom: 100,
        textAlign: "center",

        [mediaQueries.smOrSmaller]: {
            textAlign: "left",
            paddingLeft: 20,
            paddingRight: 20,
            paddingBottom: 80,
        },
        [mediaQueries.md]: {
            maxWidth: 550,
            margin: "auto",
        },
        [mediaQueries.lgOrLarger]: {
            maxWidth: 810,
            margin: "auto",
        },
    },
    paddedContainer: {
        paddingTop: 100,

        [mediaQueries.mdOrSmaller]: {
            paddingTop: 80,
        },
        [mediaQueries.smOrSmaller]: {
            paddingTop: 40,
        },
    },
    paddedBlockContainer: {
        [mediaQueries.md]: {
            paddingBottom: 55,
        },
        [mediaQueries.smOrSmaller]: {
            paddingBottom: 35,
        },
    },
});
